import { Component, Project } from "projen/lib";

/**
 * Each of the below options corresponds to a task property found here:
 *  * https://turborepo.com/docs/reference/configuration#defining-tasks
 */
export interface TurboRepoTaskOptions {
  readonly name: string;
  readonly dependsOn?: Array<string>;
  readonly env?: Array<string>;
  readonly passThroughEnv?: Array<string>;
  readonly outputs?: Array<string>;
  readonly cache?: boolean;
  readonly inputs?: Array<string>;
  readonly outputLogs?:
    "full" | "hash-only" | "new-only" | "errors-only" | "none";
  readonly persistent?: boolean;
  readonly interactive?: boolean;
}

export class TurboRepoTask extends Component {
  public readonly name: string;
  public dependsOn: Array<string>;
  public readonly env: Array<string>;
  public readonly passThroughEnv: Array<string>;
  public outputs: Array<string>;
  public cache: boolean;
  public inputs: Array<string>;
  public readonly outputLogs:
    "full" | "hash-only" | "new-only" | "errors-only" | "none";
  public readonly persistent: boolean;
  public readonly interactive: boolean;

  /**
   * Include this task in turbo.json output?
   */
  public isActive: boolean;

  constructor(
    public readonly project: Project,
    options: TurboRepoTaskOptions,
  ) {
    super(project);

    this.name = options.name;
    this.dependsOn = options.dependsOn ?? [];
    this.env = options.env ?? [];
    this.passThroughEnv = options.passThroughEnv ?? [];
    this.outputs = options.outputs ?? [];
    this.cache = options.cache ?? true;
    this.inputs = [
      ...(options.inputs ?? []),
      // rerun if projen config changes
      ".projen/**",
      // ignore mac files
      "!.DS_Store",
      "!**/.DS_Store",
    ];
    this.outputLogs = options.outputLogs ?? "new-only";
    this.persistent = options.persistent ?? false;
    this.interactive = options.interactive ?? false;
    this.isActive = true;
  }

  public taskConfig(): Record<string, any> {
    return {
      dependsOn: this.dependsOn,
      env: this.env,
      passThroughEnv: this.passThroughEnv,
      outputs: this.outputs,
      cache: this.cache,
      inputs: this.inputs,
      outputLogs: this.outputLogs,
      persistent: this.persistent,
      interactive: this.interactive,
    };
  }
}
